import mixpanel from "mixpanel-browser";

mixpanel.init(process.env.REACT_APP_ENPOWERED_MIX_PANEL_TOKEN);

export const MIXPANEL_COMPANY_GROUP_ID = "partnerCompanyId";

export const getMixpanel = () => mixpanel;
